module.exports = __webpack_public_path__ + "static/media/img4.838d8b1c.png";